<template>
	<div>
		<div class="mb-20 fs-17 fw-b text-color--dark-gray text-center">{{ $t('risoltoRiskScore') }}</div>
		<div class="risk-score">
			<el-rate :value="score" :allow-half="true" disabled></el-rate>
		</div>
		<div v-if="!score" class="text-center fs-13">
			<div class="p-5 text-color--gray">
				{{ $t("RecipientDetail.risk_score_unavailable") }}
			</div>
			<div class=" text-color--gray">
				{{ $t("RecipientDetail.risk_score_unavailable_text") }}
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		score: {
			type: Number,
			required: false,
			default: null
		}
	}
};
</script>
<style lang="scss" scoped>
.risk-score {
	display: flex;
    justify-content: space-around;
	height: 41px;

	>>>.el-rate__icon {
		font-size: 41px !important;
	}
}
</style>
